import * as React from "react";

export class SelectionsBtn extends React.Component<{
    modifier?: string;
    disabled?: boolean;
    handler?: (Event) => void;
}, {}> {
    baseClass: string;

    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-sections-btn";
    }

    render() {
        const { modifier, disabled, handler } = this.props;
        const cls = this.baseClass +
            (modifier ? ` ${this.baseClass}--${modifier}` : "");

        return (
            <button type="button" className={cls} disabled={disabled} onClick={handler}>
                {this.props.children}
            </button>
        );
    }
}